import { render, staticRenderFns } from "./BookmakerPromotionDetails.vue?vue&type=template&id=82f6e6b0&"
import script from "./BookmakerPromotionDetails.vue?vue&type=script&lang=ts&"
export * from "./BookmakerPromotionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports